import { DatasourcedWidgetMetadata } from '@/modules/ta/widget/models/metadata/DataSourcedWidgetMetadata';

export class TopPerformerWidgetMetadata extends DatasourcedWidgetMetadata {}
